/*******************************************************************************
 * api.js - API and AJAX Helpers
 ******************************************************************************/

import { API_ENDPOINTS } from './constants.js';

/**
 * Sends a log entry to the server for centralized logging
 * @param {string} logLevel - Log level: "info", "warn", "error", "debug"
 * @param {string} message - Description of the event
 * @param {object} data - Additional data to log
 */
export function logToServer(logLevel, message, data) {
    var logEntry = {
        level: logLevel,
        message: message,
        data: data
    };

    fetch(API_ENDPOINTS.LOG, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(logEntry),
    })
    .then(function(response) {
        if (!response.ok) {
            console.error('Failed to send log entry');
        }
    })
    .catch(function(error) {
        console.error('Error sending log entry to server:', error);
    });
}

/**
 * Check if connected to Xero
 * @returns {boolean} - Whether connected to Xero
 */
export function checkIfConnectedToXero() {
    var selectedTenantEl = document.querySelector('.nav-item .active');
    var selectedTenant = selectedTenantEl ? selectedTenantEl.getAttribute('data-id') : '';
    var isConnected = false;
    
    $.ajax({
        url: API_ENDPOINTS.CHECK_CONNECTED + selectedTenant,
        type: 'GET',
        async: false,
        contentType: 'application/json',
        accept: 'application/json',
        success: function(result) {
            if (result.isError) {
                var noMoreExistingOrg = typeof window.noMoreExistingOrg !== 'undefined' ? window.noMoreExistingOrg : "False";
                if (noMoreExistingOrg === "True") {
                    return;
                }
                if (typeof window.operations !== 'undefined') {
                    window.operations.errorHandling(result);
                }
                return;
            }
            isConnected = result;
        }
    });
    
    return isConnected;
}

/**
 * Create Syncfusion AJAX instance
 * @param {string} url - API endpoint
 * @param {string} type - HTTP method
 * @param {object} data - Request data
 * @returns {object} - Syncfusion Ajax instance
 */
export function createAjax(url, type, data) {
    return new ej.base.Ajax({
        url: url,
        type: type || 'GET',
        data: data ? JSON.stringify(data) : undefined,
        contentType: 'application/json',
        accept: 'application/json'
    });
}

/**
 * Make a POST request using jQuery AJAX
 * @param {string} url - API endpoint
 * @param {object} data - Request data
 * @param {Function} onSuccess - Success callback
 * @param {Function} onError - Error callback
 */
export function postJson(url, data, onSuccess, onError) {
    $.ajax({
        url: url,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        },
        success: onSuccess,
        error: onError || function(error) {
            console.error('AJAX error:', error);
        }
    });
}

/**
 * Make a GET request using fetch
 * @param {string} url - API endpoint
 * @returns {Promise} - Fetch promise
 */
export function fetchJson(url) {
    return fetch(url, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    }).then(response => response.json());
}
